import { render, staticRenderFns } from "./UserEditPage.vue?vue&type=template&id=b86b1678&scoped=true&"
import script from "./UserEditPage.vue?vue&type=script&lang=js&"
export * from "./UserEditPage.vue?vue&type=script&lang=js&"
import style0 from "./UserEditPage.vue?vue&type=style&index=0&id=b86b1678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86b1678",
  null
  
)

export default component.exports